module.exports = __webpack_public_path__ + "img/com_brunel.f53f6f77.jpg";